import React from 'react';
import PropTypes from 'prop-types';
import { Col, Empty, Row } from 'antd';
import { Title } from 'components';
import { MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import SkeletosWrappers from './SkeletosWrappers';

const { SkeletonWrapperText } = SkeletosWrappers;

const ResponsableTab = ({ plantilla, loading }) => {
  if (!plantilla?.encargadoDeResolucionName
    && !plantilla?.puestoEncargadaDeResolucion
    && !plantilla?.emailResponsableDeResolucion
    && !plantilla?.celularResponsableDeResolucion) {
    return (
      <Empty description="Este trámite no tiene responsable de resoluición" />
    );
  }

  return (
    <>
      <Row justify="center">
        <Title $accent level={3}>
          Responsable de la resolución
        </Title>
      </Row>
      <br />
      <Row>
        <Col span={24}>
          <SkeletonWrapperText
            dataLabel="Nombre"
            loading={loading}
            icon={<UserOutlined />}
          >
            {plantilla?.encargadoDeResolucionName}
          </SkeletonWrapperText>
        </Col>
        <Col span={24}>
          <SkeletonWrapperText
            dataLabel="Cargo"
            loading={loading}
            icon={<UserOutlined />}
          >
            {plantilla?.puestoEncargadaDeResolucion}
          </SkeletonWrapperText>
        </Col>
        <Col span={24}>
          <SkeletonWrapperText
            dataLabel="Correo"
            loading={loading}
            icon={<MailOutlined />}
          >
            {plantilla?.emailResponsableDeResolucion}
          </SkeletonWrapperText>
        </Col>
        <Col span={24}>
          <SkeletonWrapperText
            dataLabel="Contacto"
            loading={loading}
            icon={<PhoneOutlined />}
          >
            {plantilla?.celularResponsableDeResolucion}
          </SkeletonWrapperText>
        </Col>
      </Row>
    </>
  );
};

ResponsableTab.propTypes = {
  plantilla: PropTypes.shape({
    encargadoDeResolucionName: PropTypes.string,
    puestoEncargadaDeResolucion: PropTypes.string,
    celularResponsableDeResolucion: PropTypes.string,
    emailResponsableDeResolucion: PropTypes.string,
    rolesDeResponsableDeResolucion: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

ResponsableTab.defaultProps = {
  plantilla: {},
  loading: false,
};

export default ResponsableTab;
